module.exports = __webpack_public_path__ + "media/content-creator/fmcg-1-91bec7b2.png";